import React, { useEffect, useState } from "react";
import { Button, Box, CircularProgress, Typography } from "@material-ui/core";
import base64 from "base-64";
import Cookies from "universal-cookie";
import TagManager from 'react-gtm-module';

import Config from "../../../../../../../../../../../../controllers/config";
import Protocolos_controller from "../../../../../../../../../../../../controllers/protocolo";
import Cabecario from "../../../../../../../../../../../util/cabecario/.mixins/";
import CardPedido from "../../../../../../../../../../../util/cardPedido/.mixins/";
import ListaVazia from "../../../../../../../../../../../util/listaVazia/.mixins/ListaVazia";
import CardNotaFiscal from "../../cardNotaFiscal/index";
import ModalRadioButton from "../childrens/ModalRadioButton";
import TableModal from "../childrens/table";
import { ModalBloqueioAntecipacao } from "../../../../../../../../opcoesRecebimento/childrens/modalBloqueioAntecipacao";
import ModalAvisoSplitNota from "../../../../../../modal/modalAvisoSplitNota/.mixins/modalAvisoSplitNota";
import ModalEscolhaNovaOpcaoPag from "../../../../../../modal/modalEscolhaNovaOpcaoPag/.mixins/modalEscolhaNovaOpcaoPag";

export default function alterarOpcaoRecebimento(props) {
    useEffect(() => {
        setParams();
    }, []);

    const [isLoading, setIsLoading] = useState(false);
    const [dadosProtocoloAgendamento, setDadosProtocoloAgendamento] = useState({});
    const [detalhePedidoProtocoloNF, setDetalhePedidoProtocoloNF] = useState([]);
    const [pedidoProtocoloNFSelecionados, setPedidoProtocoloNFSelecionados] = useState({});
    const [checkboxesId, setCheckboxesId] = useState([] || null);
    const [isModalOpcoesOpen, setIsModalOpcoesOpen] = useState(false);
    const [isModalBloqueioOpen, setIsModalBloqueioOpen] = useState(false);
    const { dataAgendamento, dataAgenda, opcaoPagDias, idFornecedor } = dadosProtocoloAgendamento;
    const [isModalOpenEscolhaNovaOpcaoPag, setIsModalOpenEscolhaNovaOpcaoPag] = useState(false);
    const [isOpenModalAvisoSplitNota, setIsOpenModalAvisoSplitNota] = useState(false);
    
    function handleDialogModal() {
        setIsModalOpcoesOpen(!isModalOpcoesOpen);

        //fechar
        if (isModalOpcoesOpen) {
            TagManager.dataLayer({
                dataLayer: {
                    event: 'event',
                    eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
                    eventAction: 'clique:botao',
                    eventLabel: 'fechar',
                }
            });
        }
    }

    function handleModalBloqueio() {
        setIsModalBloqueioOpen(!isModalBloqueioOpen);
    }

    function goBack() {
        props.router.push(`/GerenciarPedidos/tab/4`);
    }

    function reload() {
        setParams();
    }

    function setItens(parms) {
        const params = {
            id_pessoa: idFornecedor,
            dt_entrg: dataAgenda,
            itens: parms,
        };
        setPedidoProtocoloNFSelecionados(params);
        handleDialogModal();
    }
    
    function setItensBotaoGeral() {
        const index = detalhePedidoProtocoloNF.findIndex((item) => parseInt(item.QT_ENTRG) > 0);
        
        if(index === -1) {
            setItens(detalhePedidoProtocoloNF);
        }
        else {
            handleModalBloqueio();
        }
    }

    function setItensBotoesIndividuais(params, rowIndex) {    
        if(!!isAntecipacaoDisponivel(rowIndex)) {
            setItens(params);
        }
        else {
            handleModalBloqueio();
        }
    }

    async function setParams() {
        const cookies = new Cookies();
        const opcaoPagamentoData = JSON.parse(base64.decode(cookies.get("OpcaoPagamentoData")));
        setDadosProtocoloAgendamento(opcaoPagamentoData);
        const filters = {
            idFornecedor: opcaoPagamentoData.idFornecedor,
            dataAgenda: opcaoPagamentoData.dataAgenda,
            codPagto: opcaoPagamentoData.codPagto,
            codFilial: opcaoPagamentoData.codFilial,
        };
        loadProtocoloNF(filters);
    }

    async function loadProtocoloNF(filters) {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");

        try {
            setIsLoading(true);
            const r_protocolo = await Protocolos_controller.getGerenciaPedidosProtocoloNF(
                token,
                filters
            );
            const j_r_protocolo = JSON.parse(r_protocolo.body);
            if (r_protocolo.res.statusCode === 200) {
                const arrayItens = j_r_protocolo.itens.map((e) => {
                    return {
                        ...e,
                    };
                });
                setDetalhePedidoProtocoloNF(arrayItens);
                setIsLoading(false);
            } else {
                if (
                    j_r_protocolo.status == false &&
                    j_r_protocolo.message &&
                    j_r_protocolo.message.includes("Token inválido!")
                ) {
                    this.childAlerta.current.retorno("Autentificação inválida!", "error");
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE") {
                errorString = error.message;
            }
            setIsLoading(false);
        }
    }

    function isAntecipacaoDisponivel(index) {
        const quantidadeEntrega = parseInt(detalhePedidoProtocoloNF[index].QT_ENTRG);
        
        if(quantidadeEntrega === 0) {
            return true;
        }
        return false;
    }

    function getProdutosModalBloqueioAntecipacao() {
        return detalhePedidoProtocoloNF
        .filter(item => parseInt(item.QT_ENTRG) === 0)
        .map((item) => ({
            nr_pedido: item.NR_PC,
            id_produto: item.ID_PROD,
        }));
    }

    const params = {
        dt_agendamento: dataAgendamento,
        ds_opcao_pag: `${opcaoPagDias} dias`,
        Ds_msg_alert: (className) => {
            return (
                <Typography>
                    {!isLoading && detalhePedidoProtocoloNF.length !== 0 && (
                        <Button
                            onClick={(e) => {
                                setItensBotaoGeral();
                                TagManager.dataLayer({
                                    dataLayer: {
                                        event: 'event',
                                        eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
                                        eventAction: 'clique:botao',
                                        eventLabel: 'alterar-opcao-recebimento-deste-grupo',
                                    }
                                });
                            }}
                            variant="outlined"
                            color="primary"
                        >
                            ALTERAR OPÇÃO DE RECEBIMENTO DESTE GRUPO
                        </Button>
                    )}
                    {isLoading && (
                        <div align={"center"} width="100%">
                            <CircularProgress />
                        </div>
                    )}
                </Typography>
            );
        },
    };
    function handleDialogEscolhaNovaOpcaoPag() {
        setIsModalOpenEscolhaNovaOpcaoPag(!isModalOpenEscolhaNovaOpcaoPag);
        setParams()
        //fechar
        if (isModalOpenEscolhaNovaOpcaoPag) {
            TagManager.dataLayer({
                dataLayer: {
                    event: 'event',
                    eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
                    eventAction: 'clique:botao',
                    eventLabel: 'fechar',
                }
            });
        }
    }
    function handleDialogModalAvisoSplitNota() {
        setIsOpenModalAvisoSplitNota(!isOpenModalAvisoSplitNota);
        setParams()
        //fechar
        if (isOpenModalAvisoSplitNota) {
            TagManager.dataLayer({
                dataLayer: {
                    event: 'event',
                    eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
                    eventAction: 'clique:botao',
                    eventLabel: 'fechar',
                }
            });
        }
    }
    return (
        <>
            <Cabecario title="Alterar opções de recebimento" goBack={goBack} />
            {isLoading && (
                <div align={"center"} width="100%">
                    <br />
                    <CircularProgress />
                </div>
            )}
            {!isLoading && detalhePedidoProtocoloNF.length <= 0 && (
                <div style={{ padding: "7px 30px 7px 30px" }}>
                    <ListaVazia
                        tipoMensagem={"Alert"}
                        text={`Por favor volte para página de protocolos agendamento`}
                        textDescription={`Não encontramos nenhum produto agendado para 
                                            ${dataAgenda} com a opção de pagamento de ${opcaoPagDias} dias`}
                    />
                </div>
            )}
            <Box p={2}>
                {!isLoading && detalhePedidoProtocoloNF.length !== 0 && (
                    <>
                        <CardPedido {...params} />
                        <TableModal
                            detalhePedidoProtocoloNF={detalhePedidoProtocoloNF}
                            handleDialogModal={handleDialogModal}
                            setItensBotoesIndividuais={setItensBotoesIndividuais}
                        />
                        <br />
                        <Typography style={{ margin: "6px" }} variant="h6">
                            Notas fiscais desta entrega
                        </Typography>
                        <CardNotaFiscal
                            dataNotaFiscal={detalhePedidoProtocoloNF}
                            title={`OPÇÕES DE PAGAMENTO: ${dadosProtocoloAgendamento.opcaoPagDias} dias`}
                        />
                    </>
                )}
            </Box>
            
            
            {isModalBloqueioOpen && (
                <ModalBloqueioAntecipacao
                    isModalOpen={isModalBloqueioOpen}
                    handleCloseModal={handleModalBloqueio}
                    produtos={getProdutosModalBloqueioAntecipacao()}
                />
            )}
            

            {isModalOpcoesOpen && (
                <ModalRadioButton
                    isModalOpen={isModalOpcoesOpen}
                    setCheckboxesId={setCheckboxesId}
                    checkboxesId={checkboxesId}
                    handleDialogModal={handleDialogModal}
                    pedidoProtocoloNFSelecionados={pedidoProtocoloNFSelecionados}
                    reload={reload}
                    handleDialogModalAvisoSplitNota={handleDialogModalAvisoSplitNota}
                    handleDialogEscolhaNovaOpcaoPag={handleDialogEscolhaNovaOpcaoPag}
                />
            )}

            <ModalEscolhaNovaOpcaoPag
                isModalOpen={isModalOpenEscolhaNovaOpcaoPag}
                handleDialogModal={handleDialogEscolhaNovaOpcaoPag}
            />
            <ModalAvisoSplitNota
                isModalOpen={isOpenModalAvisoSplitNota}
                handleDialogModal={handleDialogModalAvisoSplitNota}
            />
        </>
    );
}
